import React from "react";
import PolicyLayout from "@/components/PolicyLayout";
export default function CookiePolicy() {
  return <PolicyLayout ns="cookiePolicy" />;
}
